import { HiPlus } from 'react-icons/hi'
import { LinkButton } from '@eggplant/pattern-library'
import {
  LinkToAddGitConnection,
  useSpaceAccess
} from '@eggplant/routing'

const NewGitConnectionButton = () => {
  const [isAdmin] = useSpaceAccess(['dai:admin'])

  return isAdmin &&
    <LinkButton
      title='New Connection'
      variant='primary'
    >
      <LinkToAddGitConnection>
        <HiPlus
          aria-hidden
          size='19.2px'
        /> New Connection
      </LinkToAddGitConnection>
    </LinkButton>
}

export default NewGitConnectionButton
